var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNismSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-14 -226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2955,904h-16a2,2,0,0,1-2-2v-1a2,2,0,0,1,2-2h16a2,2,0,0,1,2,2v1A2,2,0,0,1-2955,904Zm-1.81-3.692A1.193,1.193,0,0,0-2958,901.5a1.193,1.193,0,0,0,1.191,1.193,1.192,1.192,0,0,0,1.19-1.193A1.192,1.192,0,0,0-2956.81,900.308Zm-12.932.84c-.271,0-.492.158-.492.353s.221.353.492.353h9.975c.271,0,.492-.158.492-.353s-.221-.353-.492-.353Z",
    transform: "translate(2987 -672)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2991,904h-16a2,2,0,0,1-2-2v-1a2,2,0,0,1,2-2h16a2,2,0,0,1,2,2v1A2,2,0,0,1-2991,904Zm-1.81-3.692A1.193,1.193,0,0,0-2994,901.5a1.193,1.193,0,0,0,1.191,1.193,1.192,1.192,0,0,0,1.19-1.193A1.192,1.192,0,0,0-2992.81,900.308Zm-12.932.84c-.271,0-.492.158-.492.353s.221.353.492.353h9.975c.271,0,.492-.158.492-.353s-.221-.353-.492-.353Z",
    transform: "translate(3023 -658)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2991,904h-16a2,2,0,0,1-2-2v-1a2,2,0,0,1,2-2h16a2,2,0,0,1,2,2v1A2,2,0,0,1-2991,904Zm-1.81-3.692A1.193,1.193,0,0,0-2994,901.5a1.193,1.193,0,0,0,1.191,1.193,1.192,1.192,0,0,0,1.19-1.193A1.192,1.192,0,0,0-2992.81,900.308Zm-12.932,1c-.271,0-.492.158-.492.353s.221.353.492.353h9.975c.271,0,.492-.158.492-.353s-.221-.353-.492-.353Z",
    transform: "translate(3023 -665)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNismSettings);
export default __webpack_public_path__ + "static/media/nism-settings.2e892caad99c3fd695844db997a17823.svg";
export { ForwardRef as ReactComponent };